/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdChannelsGenerate200,
  PostApiV1ClassroomdisciplineIdChannelsGenerate401,
  PostApiV1ClassroomdisciplineIdChannelsGenerate404,
  PostApiV1ClassroomdisciplineIdChannelsGenerate500,
  PostApiV1ClassroomdisciplineIdChannelsGenerateMutationResponse,
  PostApiV1ClassroomdisciplineIdChannelsGeneratePathParams,
} from "../../types/classPlanningChannelsController/PostApiV1ClassroomdisciplineIdChannelsGenerate.ts";
import { generateChannelsResultViewModelSchema } from "../generateChannelsResultViewModelSchema.ts";

export const postApiV1ClassroomdisciplineIdChannelsGeneratePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsGeneratePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ClassroomdisciplineIdChannelsGenerate200Schema = z.lazy(
  () => generateChannelsResultViewModelSchema,
) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsGenerate200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdChannelsGenerate401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsGenerate401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdChannelsGenerate404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsGenerate404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ClassroomdisciplineIdChannelsGenerate500Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsGenerate500>;

export const postApiV1ClassroomdisciplineIdChannelsGenerateMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdChannelsGenerate200Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsGenerateMutationResponse>;
